import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import Select from '../../components/forms/Select'
import ToastrAction from 'toastr/actions/ToastrAction'
import ReferencialDto from '../dto/ReferencialDto'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ReferencialAction from '../action/ReferencialAction'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import ProgressCard from 'components/card/ProgressCard'
import { hasValue } from 'utils/NumberUtil'

const MUIReplaceDialog = ({
    title = '',
    label = '',
    elements = [],

    open = false,
    onClose = () => {},
    onValidate = () => {},

    keyLabel,
    keyValue,
}) => {
    const {
        checkDelete,
    } = useSelector(store => ({
        checkDelete: store.ReferencialReducer.checkDelete,
    }), shallowEqual)

    const [selected, setSelected] = useState()

    const dispatch = useDispatch()

    useEffect(() => () => {
        dispatch(ReferencialAction.resetCheckDelete())
    }, [])

    const onReplace = () => {
        if (selected) {
            onValidate(selected)
            onClose()
        } else {
            dispatch(ToastrAction.error(i18n.chooseExistingElement))
        }
    }

    return (
        <Dialog
            maxWidth='md'
            open={open}
            slotProps={{
                paper: {
                    sx: {
                        minHeight: '35vh',
                        maxHeight: '35vh',
                    },
                },
            }}
        >
            <DefaultDialogTitle
                title={i18n.replacement}
                onClose={onClose}
            />
            <DialogContent sx={{ paddingBottom: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Grid container rowSpacing={5}>
                    <Grid size={12} sx={{ '& h4': { margin: 0 } }}>
                        <h4>{`${i18n.replacement} ${title} ${i18n.by} :`}</h4>
                    </Grid>
                    <Grid container size={12} rowSpacing={2}>
                        {!hasValue(checkDelete) ? (
                            <Grid size={12}>
                                <ProgressCard indeterminate withMessage />
                            </Grid>
                        ) : (
                            <>
                                <Grid size={12} sx={{ '& h5': { margin: 0 } }}>
                                    <h5>{`${i18n.numberOfUse}${checkDelete}`}</h5>
                                </Grid>
                                <Grid size={12}>
                                    <Select
                                        options={elements}
                                        label={`${label} :`}
                                        onChange={(_, newSelected) => setSelected(newSelected)}
                                        clearFunction
                                        displayWithCode
                                        keyLabel={keyLabel}
                                        keyValue={keyValue}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onReplace} variant='contained' color='primary'>
                    {i18n.replace}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

MUIReplaceDialog.propTypes = {
    title: PropTypes.string,
    label: PropTypes.string,
    elements: PropTypes.instanceOf(ReferencialDto),
    onValidate: PropTypes.func,
    keyLabel: PropTypes.string,
    keyValue: PropTypes.string,
    open: PropTypes.bool,
    onClose: PropTypes.func,
}

export default MUIReplaceDialog
